// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CNm8h","container":"styles_container__xkJAz","item":"styles_item__Q2n5s"};